// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1yuj3","left":"InfoRow_left__30WWo"};